var Offices = function () {

	var comp = $('[data-component="border-menu"]'),
			states = $('[data-component="states"]'),
			header = $('[data-component="header"]'),
			$id;

	this.init = function () {

		this.links();
		this.select();

		if($(window).width() <= 1024) {
			states.each(function() {
				if($(this).data('id') == comp.find('.active').data('id')){
					$(this).show();
				}
			});
		}

	}

	this.links = function () {

		comp.each(function() {

			$(this).find('a').on('click', function(e) {
				e.preventDefault();

				$id = $(this).data('id');
				$(this).closest(comp).find('a').removeClass('active');
				$(this).addClass('active');

				states.each(function() {
					if ($(this).data('id') == $id) {
						$('html, body').animate({
							scrollTop: $(this).offset().top - header.height()
						}, 700);
					}
				});
			});

		});


	}

	this.select = function () {

		$('.select').each(function(){
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		$('.select select').on('change', function() {
			$(this).prev('span').text($(this).find('option:selected').text());

			states.hide(200);

			states.each(function() {
				if($(this).data('id') == comp.find('select option:selected').val()){
					$(this).delay(201).show(300);
				}
			});
		});

	}

	return this.init();

}
